import { defineBoot } from '@quasar/app-vite/wrappers';
import WordHighlighter from 'vue-word-highlighter';

/**
 * @param {{ app: import('vue').App }} payload
 */
export default defineBoot(({ app }) => {
  app.component('TextHighlight', WordHighlighter);
});
